import { ColumnType } from "antd/lib/table";
import VinculoTag from "./VinculoTag";
import PeriodoTag from "./PeriodoTag";
import StatusTag from "./StatusTag";
import AlvosTag from "./AlvosTag";

function getColumns(
  planejamentos: any[],
  showVinculo: boolean,
  showPeriodo: boolean,
): ColumnType<any>[] {
  return [
    {
      title: "Sequência",
      dataIndex: "sequencia",
      align: "center",
      width: 120,
      render: (value: number) => <span>{value ?? "-"}</span>,
    },
    {
      title: "Operação",
      dataIndex: "operacao",
      align: "center",
      width: 200,
      render: (value: string) => <span>{value ?? "-"}</span>,
    },
    {
      title: "Referência",
      dataIndex: "planoOperacionalReferencia",
      align: "center",
      render: (value: string) => <span>{value ?? "-"}</span>,
    },
    {
      title: "Carência",
      dataIndex: "carenciaQuantidadeDias",
      align: "center",
      width: 120,
      render: (value: number) => <span>{value ?? "-"}</span>,
    },
    ...(showVinculo
      ? [{
        title: "Vínculo",
        dataIndex: "planoOperacionalOperacaoReferenciaId",
        align: "center" as const,
        width: 120,
        render: (value: string, record: any) => (
          <VinculoTag
            id={value}
            operacao={record}
            planejamentos={planejamentos}
          />
        ),
      }]
      : []),
    ...(showPeriodo
      ? [{
        title: "Período",
        dataIndex: "planoOperacionalOperacaoReferenciaId",
        align: "center" as const,
        width: 120,
        render: (value: string, record: any) => (
          <PeriodoTag
            id={value}
            operacao={record}
            planejamentos={planejamentos}
          />
        ),
      }]
      : []),
    {
      title: "Componente",
      dataIndex: "componentes",
      align: "center",
      width: 220,
      render: (value: any[]) => <span>{value.length > 0 ? value[0]?.componente : "-"}</span>,
    },
    {
      title: "Dose por ha",
      dataIndex: "componentes",
      align: "center",
      width: 120,
      render: (value: any[]) => <span>{value.length > 0 ? value[0]?.quantidade : "-"}</span>,
    },
    {
      title: "% Utilização",
      dataIndex: "componentes",
      align: "center",
      width: 120,
      render: (value: any[]) => <span>{value.length > 0 ? `${value[0]?.porcentagemUtilizacao}%` : "-"}</span>,
    },
    {
      title: "Alvos",
      dataIndex: "componentes",
      align: "center",
      width: 220,
      render: (value: any[]) => <span>{value.length > 0 && value[0]?.alvos?.length > 0 ? <AlvosTag alvos={value[0]?.alvos ?? []} /> : "-"}</span>,
    },
    {
      title: "Status",
      dataIndex: "talhoes",
      align: "center",
      render: (value: any[]) => <StatusTag status={value.length > 0 ? value[0]?.status : undefined} />,
    },
  ];
}

export default getColumns;
